"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = localeMapper;

var _legacyI18nInit = require("./legacyI18nInit");

function localeMapper(locale, locales) {
  var validLocale = (0, _legacyI18nInit.getValidLocale)(locale);
  var localeMatch = validLocale;
  var langGroup = localeMatch.split('-')[0];

  if (locales.indexOf(localeMatch) < 0 && locales.indexOf(langGroup) >= 0) {
    localeMatch = langGroup;
  } else if (locales.indexOf(localeMatch) < 0) {
    localeMatch = null;
  }

  return localeMatch;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/init/internal/localeMapper.js
// module id = 315
// module chunks = 209 210 211 212 213